module.exports = __webpack_public_path__ + "img/cover_image.57ac984b.png";